import styled from 'styled-components';

export const Container = styled.div``;

export const Item = styled.div`
  display: flex;
  margin-bottom: 24px;
  color: #202020;
  font-size: 14px;
  font-weight: 500;

  &.items {
    margin-bottom: 16px;
  }

  p {
    width: 128px;
    height: 24px;
    margin-top: 4px;
  }

  & > * {
    width: 624px;
    display: flex;
  }

  & > * > div {
    width: 624px;
  }

  & > * > span.tilde {
    width: 24px;
    line-height: 30px;
    text-align: center;
    font-weight: 700;
  }

  .ant-input-disabled {
    color: #202020;
  }

  &.textarea {
    margin: 0;
  }

  &.textarea > *:nth-child(2) {
    height: 88px;
  }

  &.checkBox {
    margin-top: 16px;
  }
`;
